export default __webpack_public_path__ + "img/egpEmjNh.65f61f40.svg";